/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ type: NonNullable<unknown>, date: NonNullable<unknown> }} Members_Seat_ScheduledInputs */



/**
* | output |
* | --- |
* | "{type} from {date}" |
*
* @param {Members_Seat_ScheduledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_seat_scheduled = /** @type {((inputs: Members_Seat_ScheduledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Seat_ScheduledInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.type} ab ${i?.date}`)
	return /** @type {LocalizedString} */ (`${i?.type} from ${i?.date}`)
});